import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { PartNumberModel } from './partNumber.model'
import { environment } from '../../../../environments/environment'
import { catchError, map, Observable } from 'rxjs'

const API_URL = environment.apiUrl
@Injectable({
  providedIn: 'root',
})
export class PartNumberService {
  constructor(private http: HttpClient) {}

  addPartNumber(partnumber: PartNumberModel) {
    return this.http
      .post(API_URL + '/PartNumber/CreatePartNumber', partnumber, {
        withCredentials: true,
      })
      .pipe(
        map((response: any) => {
          return response
        }),
        catchError((error: any) => {
          

          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }

  updatePartNumber(partnumber: PartNumberModel) {
    
    return this.http
      .put(API_URL + '/PartNumber/UpdatePartNumber', partnumber, {
        withCredentials: true,
      })
      .pipe(
        map((response: any) => {
          return response
        }),
        catchError((error: any) => {
          

          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }

  getAllPartNumbers(): Observable<PartNumberModel[]> {
    return this.http
      .get(API_URL + '/PartNumber/ReadPartNumbers', {
        withCredentials: true,
      })
      .pipe(
        map((response: any) => {
          return response
        }),
        catchError((error: any) => {
          

          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }

  deletePartNumber(partnumber: PartNumberModel) {
    
    return this.http
      .delete(API_URL + '/PartNumber/DeletePartNumber', {
        headers: {},
        body: partnumber,
        withCredentials: true,
      })
      .pipe(
        map((response: any) => {
          return response
        }),
        catchError((error: any) => {
          

          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }
}
